import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { withRouter } from 'react-router-dom';
import { CentreSelector as SharedCentreSelector } from '../../../../components/centre-selector';
import headerStyles from '../index.module.scss';
import navStyle from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const style = _objectSpread(_objectSpread({}, headerStyles), navStyle);

export const CentreSelector = withRouter(({
  centres,
  centre: currentCentre,
  onClose
}) => /*#__PURE__*/_jsx(SharedCentreSelector, {
  centres: centres,
  centre: currentCentre,
  navStyle: style,
  onClose: onClose
}));